import { HttpStatusCode as AxiosCode } from 'axios';

export const HttpStatusCodes = Object.freeze({
  BAD_REQUEST: AxiosCode.Conflict,
});
